
import {PropType}     from "@vue/runtime-core";
import {Options, Vue} from "vue-class-component";
import BusEvent       from "../../../../shared/js/BusEvent";

export type IFloatingActionButtonPosition =
  | "top-left"
  | "top-right"
  | "bottom-left"
  | "bottom-right";

@Options({
           props: {
             position: Object as PropType<IFloatingActionButtonPosition>,
             show:     Boolean,
             classes:  Array as PropType<string[]>
           },
           emits: ["clicked"],
         })
export default class ModalBooklet extends Vue
{
  // declare properties
  position!: IFloatingActionButtonPosition;
  classes: string[] = [];

  click()
  {
    this.$emit("clicked");

    const ev = new BusEvent(BusEvent.EVENTS.CLOSE_TUTORIAL);
    document.dispatchEvent(ev);

  }

  mounted()
  {

  }
}
